import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getTaxListByHsCode, taxCalculator } from '@/modules/hs/api/hs-tax.api'

export const useHsTaxListByHsCode = (hsCode: string) => {
  return useQuery({
    queryKey: ['tax', hsCode],
    queryFn: () => getTaxListByHsCode(hsCode),
    enabled: !!hsCode,
  })
}

export const useTaxCalculator = (
  hsCode: string,
  countryName: string,
  importDate: string,
) => {
  return useQuery({
    queryKey: ['tax-calculator', hsCode, countryName, importDate],
    queryFn: () => taxCalculator(hsCode, countryName, importDate),
    retry: 1,
    placeholderData: keepPreviousData,
    enabled: hsCode !== '' && !!countryName && !!importDate,
  })
}
